import type {
  ConsentGoneBody,
  ConsentLoadResult,
  ConsentSubmitResult,
  PartnerConsentPreload,
  SubmitPartnerConsentBody,
  SubmitPartnerConsentResponse,
} from './types';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

function endpoint(token: string): string {
  return `${API_BASE_URL}/api/consent/${encodeURIComponent(token)}`;
}

export async function fetchConsent(token: string): Promise<ConsentLoadResult> {
  try {
    const res = await fetch(endpoint(token), {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });

    if (res.status === 200) {
      const data = (await res.json()) as PartnerConsentPreload;
      return { kind: 'preload', data };
    }

    if (res.status === 410) {
      const body = (await res.json().catch(() => ({ reason: 'Invalid' }))) as ConsentGoneBody;
      return { kind: 'gone', reason: body.reason ?? 'Invalid' };
    }

    if (res.status === 404) {
      return { kind: 'gone', reason: 'Invalid' };
    }

    return { kind: 'error' };
  } catch {
    return { kind: 'error' };
  }
}

export async function submitConsent(
  token: string,
  body: SubmitPartnerConsentBody,
): Promise<ConsentSubmitResult> {
  try {
    const res = await fetch(endpoint(token), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });

    if (res.status === 200) {
      const data = (await res.json()) as SubmitPartnerConsentResponse;
      return { kind: 'success', consentApplicationId: data.consentApplicationId };
    }

    if (res.status === 410) {
      const data = (await res.json().catch(() => ({ reason: 'Invalid' }))) as ConsentGoneBody;
      return { kind: 'gone', reason: data.reason ?? 'Invalid' };
    }

    if (res.status === 404) {
      return { kind: 'gone', reason: 'Invalid' };
    }

    return { kind: 'error' };
  } catch {
    return { kind: 'error' };
  }
}
